
import React,{useContext, useState, useEffect} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { SITE_TITLE, INDEX_URL } from '../../settings/common';
import { AppContext } from '../../helpers/AppContext';
import { decrypt } from '../../helpers/encryption';
import { seo } from '../../settings/seo';
import { Validation } from '../../helpers/validation';
import WAServices from '../../services/WAServices';
import { showSuccessMessage, showErrorMessage } from '../../helpers/flash-messages';
import { encrypt } from '../../helpers/encryption';
import { Overlay } from '../../helpers/Overlay';

const ProfilePage = () => {
	const [formData, setFormData] = useState({});
	const [errors, setErrors] = useState({});
	const [authUser, setAuthUser] = useState({});
    const {isSidebarHidden, setSidebarHidden } = useContext(AppContext);
    const { SharedAuthUser } = useContext(AppContext);
    const [showEdit , setShowEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const { setSharedAuthUser } = useContext(AppContext);
    const navigate = useNavigate();
    const waServices = new WAServices();

    useEffect(() => {
        const auth_user = decrypt('__bs_auth_user');
        console.log(auth_user);
        if (Object.keys(SharedAuthUser).length > 0) {
            setAuthUser(SharedAuthUser);
        } else if (auth_user) {
            setAuthUser(auth_user);
        } else {
            setAuthUser({});
        }
    }, [SharedAuthUser]);

    useEffect(() => {
	    if (authUser) {
	        const newFormData = {
	            first_name: authUser.first_name,
	            last_name: authUser.last_name,
	            email: authUser.email,
	        };
	        setFormData(newFormData);
	    }
	}, [authUser]);

    useEffect(() => {
        seo({
            title: SITE_TITLE + ' || Profile',
            metaDescription: '',
        });
    },[]);

    const handleClick = () =>{
        setShowEdit(!showEdit);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newFormData = {
            ...formData,
            [name]: value,
        };
        setFormData(newFormData);
    };

    const handleSubmit = (e) => {
    	console.log(formData);
        e.preventDefault();
        const errors = Validation(formData,['first_name','last_name','email']);
        if (Object.keys(errors).length > 0) {
          setErrors(errors);
          return;
        }
        submitForm();
    };

    const submitForm = async () => {
    	setLoading(true);
        try {
	        waServices.updateProfile(authUser.auth_token,formData).then(response => {
	        	if(typeof response !== 'undefined') {
		        	const data = response.data;
		        	if(response.status === 200 && data.status === 'success') {
		        		setShowEdit(false);
		        		encrypt(data.data, '__bs_auth_user');
		        		setSharedAuthUser(data.data);
		        		showSuccessMessage(`${data.message}`);
		        	} else {
		        		showErrorMessage(`${data.message}`)
		        	}
		        } else {
		        	showErrorMessage('Server error: Something went wrong. Please try again later.');
		        }
		        setLoading(false);
	        });
	    } catch (error) {
	        // Check for server-side error (500)
	        if (error.response && error.response.status === 500) {
	            showErrorMessage('Server error: Something went wrong. Please try again later.');
	        } else {
	            // Handle other types of errors, such as network errors
	            showErrorMessage('An error occurred. Please check your connection and try again.');
	        }
	    }
    }

    const renderForm = () => {
    	return (
		    <React.Fragment>
		        <form className="row g-3 mb-3" onSubmit={handleSubmit}>
		            <div className="col-md-6">
		                <label htmlFor="first_name" className="form-label">First name</label>
		                {showEdit ? (
		                    <>
		                        <input
		                            type="text"
		                            id="first_name"
		                            name="first_name"
		                            value={formData.first_name}
		                            onChange={handleChange}
		                            className="form-control slug-title"
		                        />
		                        {errors.first_name && <div className="text-danger">{errors.first_name}</div>}
		                    </>
		                ) : (
		                    <span className="form-control-plaintext slug-title">{formData.first_name}</span>
		                )}
		            </div>
		            <div className="col-md-6">
		                <label htmlFor="last_name" className="form-label">Last name</label>
		                {showEdit ? (
		                    <>
		                        <input
		                            type="text"
		                            id="last_name"
		                            name="last_name"
		                            value={formData.last_name}
		                            onChange={handleChange}
		                            className="form-control slug-title"
		                        />
		                        {errors.last_name && <div className="text-danger">{errors.last_name}</div>}
		                    </>
		                ) : (
		                    <span className="form-control-plaintext slug-title">{formData.last_name}</span>
		                )}
		            </div>
		            <div className="col-md-12">
		                <label htmlFor="email" className="form-label">Email</label>
		                {showEdit ? (
		                    <>
		                        <input
		                            type="email"
		                            id="email"
		                            name="email"
		                            value={formData.email}
		                            onChange={handleChange}
		                            className="form-control here set-slug"
		                        />
		                        {errors.email && <div className="text-danger">{errors.email}</div>}
		                    </>
		                ) : (
		                    <span className="form-control-plaintext set-slug">{formData.email}</span>
		                )}
		            </div>
		            {showEdit && (
		                <React.Fragment>
		                    <div className="col-md-12">
		                        <button type="submit" className="cx-btn cx-btn-primary">Save</button>&nbsp;
		                        <button type="button" onClick={handleClick} className="cx-btn cx-btn-primary">Cancel</button>
		                    </div>
		                </React.Fragment>
		            )}
		        </form>
		    </React.Fragment>
		);

    }

    return (
       <React.Fragment>
           <div className={`cx-main-content ${isSidebarHidden ?'sb-hide':'' }`}>
	           <div className="cx-breadcrumb">
					<div className="cx-page-title cx-page-title-2">
						<h5>Profile</h5>
						<ul>
							<li><Link to={`${INDEX_URL}dashboard`}>Dashborad</Link></li>
							<li>Profile</li>
						</ul>
					</div>
			   </div>
			   <div className="row">
					<div className="col-xxl-4 col-xl-4 col-md-12">
						<div className="sub-card user-sticky-bar">
							<div className="cx-card-content">
								<div className="cx-user-block-img">
									<div className="cx-user-block-detail">
										<div className="profile-img">
											<img className="v-img" src={`${process.env.PUBLIC_URL}/assets/image/profile.png`} alt="user image"/>
											<span className="tag-label online"></span>
										</div>
										<h5 className="name">{`${authUser.first_name} ${authUser.last_name}`}</h5>
										<p>( {`${authUser.email}`} )</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="col-xxl-8 col-xl-8 col-md-12">
						<div className="cx-card">
							<div className="cx-card-content user-details mb-m-30">

								<div className="row">
									<div className="col-sm-10">
										<h3>User Details</h3>
										{/* <div className="cx-user-detail">
											<p>From your account you can easily view and track orders. You can manage
												and change your account information like address, contact information
												and history of orders.</p>
										</div> */}
									</div>
									<div className="col-sm-2">
										<button type="button" className="btn action-btn">
											<span className="sr-only" onClick={handleClick}>
												<i className="ri-pencil-line"></i>
											</span>
										</button>
									</div>
									<div className="col-xxl-6 col-xl-12 col-md-12 col-sm-12">
										{renderForm()}
									</div>
			
								</div>
							</div>
						</div>
					</div>
			   </div>
			   {/* Show loading overlay when `loading` is true */}
	            {loading && (
	                <Overlay />
	            )}
		   </div>
       </React.Fragment>
    );
};

export default ProfilePage;